export default "__VITE_ASSET__BT1v27rR__"